<button *ngIf="template == null" class="button-delete" (click)="modalDelete()" type="button" title="Excluir esse item do carrinho.">
      EXCLUIR
</button>
<button *ngIf="template == 'two'" class="button-delete-two" (click)="deletar()" type="button" title="Excluir esse item do carrinho.">
      Remover
</button>
    